export default {
    BASE_URL: '//mm/shopping',
    api: [
        {
            name: 'selectProdCondition',
            desc: '获取筛选条件', // 传递二级分类
            method: 'GET',
            path: 'selectProdCondition'
        },
        {
            name: 'list',
            desc: '获取商品',
            method: 'GET',
            path: 'selectProds',
            params: {
                cataId: '', // 三级分类id
                keyword: '',
                paras: {}, // 筛选条件
                orderKey: '', // 排序字段
                orderMode: 'desc' // 排序规则
            }
        },
        {
            name: 'detail',
            desc: '获取商品详情',
            method: 'GET',
            path: 'getProd',
            params: {
                skuId: ''
            }
        }
    ]
}
  


// WEBPACK FOOTER //
// ./src/api/apis/mall/prod.js